import { MenuItem, Select } from "@mui/material";

/**
 * How an alert reaches the user (ortex/ted/ted#2485). "In app" is the notifications bell
 * and, with the ORTEX app installed, a push to the phone; there is no separate push
 * choice. The backend still knows the older "push" and "all" values: they show as
 * "In app" and "In app and email", which is what they now mean.
 *
 * A themed MUI select, not a native <select>: the browser draws a native list itself
 * and ignores the page's dark theme (white list, unreadable options).
 */
export type DeliveryValue = "in_app" | "email" | "both";

const OPTIONS: { value: DeliveryValue; label: string }[] = [
    { value: "in_app", label: "In app" },
    { value: "email", label: "Email" },
    { value: "both", label: "In app and email" },
];

/** The option a stored value shows as ("push" is in app, "all" is in app and email). */
export const toDeliveryValue = (value: string): DeliveryValue => {
    if (value === "push") return "in_app";
    if (value === "all") return "both";
    return value === "email" || value === "both" ? value : "in_app";
};

interface Props {
    value: string;
    onChange: (value: DeliveryValue) => void;
    disabled?: boolean;
    ariaLabel?: string;
}

const DeliverySelect = ({ value, onChange, disabled, ariaLabel = "Delivery" }: Props) => (
    <Select
        size="small"
        value={toDeliveryValue(value)}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value as DeliveryValue)}
        inputProps={{ "aria-label": ariaLabel }}
        sx={{ fontSize: 12.5, minWidth: 150, "& .MuiSelect-select": { py: 0.5 } }}
    >
        {OPTIONS.map((o) => (
            <MenuItem key={o.value} value={o.value} sx={{ fontSize: 13 }}>
                {o.label}
            </MenuItem>
        ))}
    </Select>
);

export default DeliverySelect;
